<template>
  <div>
    <div style="margin-bottom: 10px">
      <div style="margin: 10px 0 0 10px; font-size: 14px; color: red;word-break: break-word;">剩余可用代码：{{unUsedIndex.join(",")}}</div>
      <el-button type="primary" @click="$refs.systemFunctionEdit.open()">新建</el-button>
    </div>
    <el-table
        v-loading="contentLoading"
        :data="tableData"
        row-key="id"
        border
        stripe
        :tree-props="{ children: 'children' }">
      <el-table-column prop="other" label="编码" width="120"/>
      <el-table-column prop="label" label="名称"/>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button
              v-if="limits.addAuth"
              size="mini"
              type="primary"
              @click="$refs.systemFunctionEdit.open(scope.row, 0,unUsedIndex[0])">
            新建
          </el-button>
          <el-button
              v-if="limits.editAuth"
              size="mini"
              type="primary"
              @click="$refs.systemFunctionEdit.open(scope.row, 1)">
            编辑
          </el-button>
          <el-button v-if="limits.delAuth" size="mini" type="danger" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <system-function-edit ref="systemFunctionEdit" @save-success="getData"/>
  </div>
</template>

<script>
  import SystemFunctionEdit from "./SystemFunctionEdit";

  export default {
    components: {
      SystemFunctionEdit,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(27),
          editAuth: this.$auth(28),
          delAuth: this.$auth(29),
        },
        tableData: [],
        contentLoading: false,
        unUsedIndex: "",
      };
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", "functions/tree")
          .then((res) => {
            if (res.success) {
              this.tableData = res.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });

        this.$http
          .get("basic", "functions/unUsed")
          .then((res) => {
            if (res.success) {
              if (res.data.length > 0) {
                this.unUsedIndex = res.data;
              }
            }
          });
      },

      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "functions", row.id).then((resp) => {
            if (resp.success) {
              this.getData();
              this.$message.success("删除成功");
            }
          });
        });
      },
    },
  };
</script>
